const NAMESPACE = 'jbp-assortment-tab'

const SAVE_CONFIRM = `${NAMESPACE}--save-confirm`
const DELETE_CONFIRM = `${NAMESPACE}--delete-confirm`
const APPLICABLE_CONFIRM = `${NAMESPACE}--applicable-confirm`
const GROUP_NAMESPACE = `${NAMESPACE}--group`
const ITEM_NAMESPACE = `${NAMESPACE}--item`

export const TRANSLATION_KEYS = {
  group: {
    addGroup: `${GROUP_NAMESPACE}--add-group-label`,
    groupNameLabel: `${GROUP_NAMESPACE}--name-label`,
    businessPercentageLabel: `${GROUP_NAMESPACE}--business-percentage-label`,
    buisnessPercentage: `${GROUP_NAMESPACE}--business-percentage`,
    unitsCountLabel: `${GROUP_NAMESPACE}--units-count-label`,
    unitsCount: `${GROUP_NAMESPACE}--units-count`,
    tooltips: {
      deleteTooltip: `${GROUP_NAMESPACE}--delete-button-tooltip`,
      editTooltip: `${GROUP_NAMESPACE}--edit-button-tooltip`,
      saveTooltip: `${GROUP_NAMESPACE}--save-button-tooltip`,
      cancelTooltip: `${GROUP_NAMESPACE}--cancel-button-tooltip`,
      addTooltip: `${GROUP_NAMESPACE}--add-button-tooltip`,
    },
  },
  item: {
    focus: `${ITEM_NAMESPACE}--focus`,
    suppliers: `${ITEM_NAMESPACE}--suppliers`,
    suppliersLabel: `${ITEM_NAMESPACE}--suppliers-label`,
    units: `${ITEM_NAMESPACE}--units`,
    configs: `${ITEM_NAMESPACE}--configs`,
    configurations: `${ITEM_NAMESPACE}--configurations`,
    configurationsPlaceholder: `${ITEM_NAMESPACE}--configurations-placeholder`,
    productCode: `${ITEM_NAMESPACE}--product-code`,
    comments: `${ITEM_NAMESPACE}--comments`,
    commentsPlaceholder: `${ITEM_NAMESPACE}--comments-placeholder`,
    status: `${ITEM_NAMESPACE}--status`,
    statusText: `${ITEM_NAMESPACE}--status-text`,
    tooltips: {
      deleteTooltip: `${ITEM_NAMESPACE}--delete-button-tooltip`,
      editTooltip: `${ITEM_NAMESPACE}--edit-button-tooltip`,
      saveTooltip: `${ITEM_NAMESPACE}--save-button-tooltip`,
      cancelTooltip: `${ITEM_NAMESPACE}--cancel-button-tooltip`,
    },
  },
  saveConfirm: {
    saveButton: `${SAVE_CONFIRM}--save-label`,
    cancelButton: `${SAVE_CONFIRM}--cancel-label`,
    saveMessage: `${SAVE_CONFIRM}--save-message`,
  },
  deleteConfirm: {
    deleteButton: `${DELETE_CONFIRM}--delete-label`,
    cancelButton: `${DELETE_CONFIRM}--cancel-label`,
    deleteItemMessage: `${DELETE_CONFIRM}--delete-item`,
    deleteGroupMessage: `${DELETE_CONFIRM}--delete-group`,
  },
  applicablePlaceholder: `${NAMESPACE}--not-applicable-placeholder`,
  applicableConfirm: {
    message: `${APPLICABLE_CONFIRM}--message-label`,
    okButton: `${APPLICABLE_CONFIRM}--ok-label`,
    cancelButton: `${APPLICABLE_CONFIRM}--cancel-label`,
  },
  emptyState: {
    message: `${NAMESPACE}--empty-message`,
    button: `${NAMESPACE}--empty-button`,
  },
}
